import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const cities = [
  "Stockton",
  "Tracy",
  "Manteca",
  "Lodi",
  "Ripon",
  "Escalon",
  "Lathrop",
  "Mountain House",
];

const ServiceAreaSection = () => (
  <section
    id="service-area"
    data-testid="service-area-section"
    className="py-20 lg:py-28 bg-[#F4F1FA] border-y border-[#E6E0F0] relative overflow-hidden"
  >
    <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[#6D28D9]/10 blur-3xl -z-0" />
    <div className="absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-[#F5B301]/10 blur-3xl -z-0" />

    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 text-center relative">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-3xl mx-auto"
      >
        <div
          data-testid="service-area-badge"
          className="inline-flex items-center gap-2 rounded-full border-2 border-[#2B1B45] bg-white px-4 py-1.5 mb-6"
        >
          <MapPin className="h-3.5 w-3.5 text-[#2563EB]" />
          <span className="text-xs uppercase tracking-[0.22em] font-heading font-bold text-[#2B1B45]">
            Service Area
          </span>
        </div>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#2B1B45] leading-tight mb-6">
          Serving San Joaquin County &amp;{" "}
          <span className="font-serif italic font-semibold text-[#6D28D9]">
            surrounding communities
          </span>
        </h2>
        <p className="text-base sm:text-lg text-[#5B5470] leading-relaxed mb-12">
          Based in Tracy and serving families throughout the county, in your
          home, at your birth center, or by your side at the hospital.
        </p>
      </motion.div>

      <div data-testid="service-area-city-list" className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
        {cities.map((city, i) => (
          <motion.span
            key={city}
            initial={{ opacity: 0, scale: 0.85 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ scale: 1.06, y: -2 }}
            className="font-heading font-bold text-base sm:text-lg px-6 py-2.5 rounded-full bg-white border-2 border-[#2B1B45]/15 text-[#2B1B45] shadow-sm hover:border-[#6D28D9] hover:text-[#6D28D9] hover:shadow-md transition-colors duration-300 cursor-default"
          >
            {city}
          </motion.span>
        ))}
      </div>
    </div>
  </section>
);

export default ServiceAreaSection;
